import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL + "/api";

const api = axios.create({
    baseURL: API_BASE_URL,
});

// Функция обновления токена
const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refresh_token");

    if (!refreshToken) {
        console.warn("Отсутствует refresh_token, разлогиниваем...");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        window.location.href = "/admin/login";
        return null;
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/token/refresh`, {
            refresh_token: refreshToken,
        });

        localStorage.setItem("token", response.data.access_token);
        return response.data.access_token;
    } catch (err) {
        console.warn("Ошибка обновления токена:", err);
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        window.location.href = "/admin/login";
    }
};

// **Добавляем токен в заголовки, кроме логина и refresh-токена**
api.interceptors.request.use(
    async (config) => {
        if (config.url === "/login" || config.url === "/token/refresh") {
            return config; // Пропускаем запрос без токена
        }

        let token = localStorage.getItem("token");

        if (!token) {
            console.warn("Токен отсутствует, разлогиниваем...");
            window.location.href = "/admin/login";
            return Promise.reject("Не авторизован");
        }

        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// **Обрабатываем 401 и обновляем токен**
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response && error.response.status === 401) {
            console.warn("Токен истек, пытаемся обновить...");
            const newToken = await refreshAccessToken();

            if (newToken) {
                error.config.headers.Authorization = `Bearer ${newToken}`;
                return axios(error.config);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
